<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition"
       [ngClass]="{'-is-open esf-main-sidebar--working-space--extra-width' : userModalService.modalOpened}">
  <div class="esf-main-sidebar__content">
    <h3 i18n='Edit user workspace title@@userOverviewComponent.heading.editUser'>Edit User</h3>
    <form [formGroup]="userForm" (ngSubmit)="submitUser()" id="editUserForm">
      <div class="esf-form-group">
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [control]="userForm.get('username')"
             [placeholder]="flTranslations.i18nUsername"
             [label]="flTranslations.i18nUsername">
        </div>
        <div app-form-field-password
             *ngIf="userForm.get('password')"
             class="esf-form-item--1-2"
             [label]="flTranslations.i18nPassword"
             [control]="userForm.get('password')">
        </div>
      </div>
      <div class="esf-form-group">
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [control]="userForm.get('firstName')"
             [placeholder]="flTranslations.i18nFirstName"
             [label]="flTranslations.i18nFirstName">
        </div>
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [control]="userForm.get('lastName')"
             [placeholder]="flTranslations.i18nLastName"
             [label]="flTranslations.i18nLastName">
        </div>
      </div>
      <div app-form-field-text-generic
           [control]="userForm.get('email')"
           [placeholder]="flTranslations.i18nEmail"
           [label]="flTranslations.i18nEmail">
      </div>
      <div class="esf-form-item">
        <label i18n='Form label text@@general.formLabel.sessionExpiration' class="esf-form-item__label" for="token_expiration">Session expiration</label>
        <div class="esf-select">
          <select class="esf-form-item__field esf-select__field" id="token_expiration" formControlName="tokenLifetime">
            <option [value]=3600>1 <span>{{ flTranslations.i18nHour }}</span></option>
            <option [value]=28800>8 <span>{{ flTranslations.i18nHours }}</span></option>
          </select>
        </div>
      </div>

      <ng-container *ngIf="(authenticatedUser.isAdmin || authenticatedUser.isClubAdmin) && (user.type == 'ClubAdmin' || user.type == 'TicketAgent')">
        <div class="esf-form-item esf-form-validation">
          <label class="esf-form-item__label" i18n='Form label text@@general.formLabel.userType'>User type</label>
          <div class="esf-select" controlErrorContainer>
            <select class="esf-form-item__field esf-select__field" formControlName="type" id="type">
              <option i18n='Form label text@@general.formLabel.clubAdmin' value="ClubAdmin">Club Admin</option>
              <option i18n='Form label text@@general.formLabel.ticketAgent' value="TicketAgent">Ticket Agent</option>
            </select>
          </div>
        </div>
      </ng-container>

      <div class="esf-form-item">
        <label i18n='Form label text@@general.formLabel.active' class="esf-form-item__label">Active</label>
        <div class="esf-toggle">
          <input class="esf-toggle__input" type="checkbox" id="enabled" formControlName="enabled">
          <label class="esf-toggle__label" for="enabled">
            <div class="esf-toggle__button">
              <div class="esf-toggle__button-background">
                <div class="esf-toggle__button-handle"></div>
              </div>
            </div>
          </label>
        </div>
      </div>
      <div class="esf-form-item" *ngIf="(authenticatedUser.isAdminType)">
        <label i18n='Form label text@@general.formLabel.forcePasswordResetNextLogin' class="esf-form-item__label">Force password reset on next login</label>
        <div class="esf-toggle">
          <input class="esf-toggle__input" type="checkbox" id="passwordToggle" formControlName="forcePasswordChange">
          <label class="esf-toggle__label" for="passwordToggle">
            <div class="esf-toggle__button">
              <div class="esf-toggle__button-background">
                <div class="esf-toggle__button-handle"></div>
              </div>
            </div>
          </label>
        </div>
      </div>

    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open">
  <app-submit-row-buttons [form]="'editUserForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="userModalService.toggleModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space -has-transition -is-open"
     (click)="userModalService.toggleModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
